// extracted by mini-css-extract-plugin
module.exports = {"page":"menu_page__1cIHi","menu-row":"menu_menu-row__M7x6Z"};